// Ported verbatim from the LeadMailer Design System (components/core/IconButton.jsx).
import React from 'react'
import type { ControlSize } from './Button'

export interface IconButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label'> {
  label: string
  size?: ControlSize
  variant?: 'ghost' | 'secondary'
}

export function IconButton({
  label,
  size = 'md',
  variant = 'ghost',
  disabled,
  children,
  style,
  ...rest
}: IconButtonProps) {
  const [hover, setHover] = React.useState(false)
  const dim = {
    sm: 'var(--control-h-sm)',
    md: 'var(--control-h-md)',
    lg: 'var(--control-h-lg)',
  }[size]

  const base: React.CSSProperties =
    variant === 'secondary'
      ? {
          background: 'var(--surface-card)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-xs)',
        }
      : { background: 'transparent', border: '1px solid transparent' }

  return (
    <button
      aria-label={label}
      title={label}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: dim,
        height: dim,
        borderRadius: 'var(--radius-sm)',
        color: hover ? 'var(--text-primary)' : 'var(--text-secondary)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background var(--dur-fast) var(--ease-out)',
        ...base,
        ...(hover && !disabled ? { background: 'var(--surface-sunken)' } : {}),
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  )
}
